if (!customElements.get('bulk-discount-table')) {
  customElements.define('bulk-discount-table', class BulkDiscountTable extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.bulk-discount-table__body');
      this.pcs = 'pcs';
      if(this.body.dataset.pcs != '') {
        this.pcs = this.body.dataset.pcs;
      }

      console.log('pcs', this.pcs);
      
      this.render();
    }

    render() {
      const rawDiscount = this.dataset.discount;

      if (!rawDiscount || !this.body) {
        return;
      }

      let discountGroups;
      try {
        discountGroups = JSON.parse(rawDiscount);
      } catch (e) {
        console.error('[BulkDiscountTable] JSON.parse failed:', e.message, '| raw value:', rawDiscount);
        return;
      }

      const wordDiscount = this.dataset.wordDiscount || 'Discount';
      const breaks = discountGroups[0]?.breaks;
      if (!breaks?.length) {
        console.warn('[BulkDiscountTable] no breaks found in first group');
        return;
      }

      this.body.innerHTML = '';

      breaks.forEach((item, index, arr) => {
        const nextQuantity = arr[index + 1]?.quantity;
        const quantityRange = nextQuantity
          ? `${item.quantity} - ${nextQuantity - 1} ${this.pcs}`
          : `>${item.quantity - 1} ${this.pcs}`;

        const row = document.createElement('div');
        row.className = 'bulk-discount-table__row';

        const quantitySpan = document.createElement('span');
        quantitySpan.textContent = quantityRange;

        const discountSpan = document.createElement('span');
        discountSpan.className = 'bulk-discount-table__row-discount body-bold';
        discountSpan.textContent = `${item.percentage}% ${wordDiscount}`;

        row.appendChild(quantitySpan);
        row.appendChild(discountSpan);
        this.body.appendChild(row);
      });
    }
  });
}
